import React from "react";
import { Breadcrumbs } from "@ocm_customer/account_navigation";
import { ErrorBoundary } from "@thd-olt-component-react/error-boundary";
import SignInDetails from "../components/SignInSecurity/SignInDetails";
import { StencilGlobalAlert } from "../components/common/StencilGlobalAlert";
import LoadingProvider from "../components/SignInSecurity/LoadingProvider";
import AccountProvider from "../components/SignInSecurity/AccountProvider";
import Loading from "../components/common/Loading/Loading";
import CommonContextProvider from "../components/SignInSecurity/CommonProvider";
import DeviceManagement from "../components/SignInSecurity/DeviceManagement";
import { isNativeApp, isAccountActivityLogEnabled } from "../utils";
import { CustomerAccountNavigation, useAccountCrumbs } from "@thd-olt-component-react/customer-account-navigation";
import { QueryProvider } from "@thd-nucleus/data-sources";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import { AccountActivityLog , ActivityLogProvider} from "@thd-olt-component-react/account_activity_log";
import {Typography} from "@one-thd/sui-atomic-components";
import ApiContextProvider from "../contexts/ApiContext";

export function HomeHOC({recaptchaV3Key}) {
  return (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaV3Key}>
        <ActivityLogProvider>
          <CommonContextProvider>
              <ApiContextProvider>
                  <LoadingProvider>
                      <Loading isLoading />
                      <Home />
                  </LoadingProvider>
              </ApiContextProvider>
          </CommonContextProvider>
          </ActivityLogProvider>
      </GoogleReCaptchaProvider>
  )
}

function AccountActivityLogComponent() {
  if(!isAccountActivityLogEnabled()) {
    return null;
  }
  return (
      <ErrorBoundary name="account-activity-log">
          <AccountActivityLog/>
      </ErrorBoundary>
  );
}

export function Home() {
  const crumbs = useAccountCrumbs([{ label: "Security & Password" }]);

  return (
    <div className="sui-grid sui-grid-cols-12  sui-p-3">
      <div className="sui-grid sui-col-start-1 sui-col-end-13 2xl:sui-col-start-3 2xl:sui-col-span-9">
          <div className='sui-grid sui-gap-4'>
              {!isNativeApp() && (
                  <ErrorBoundary name="breadcrumbs">
                      <Breadcrumbs crumbs={crumbs}/>
                  </ErrorBoundary>
              )}
              <Typography weight="display" variant="h1" uppercase>
                  Security & Password
              </Typography>
              <div className='sui-grid sui-grid-cols-12'>
                  <div className='sui-hidden lg:sui-block sui-col-span-3'>
                      <ErrorBoundary name="responsive-left-nav">
                          <QueryProvider cacheKey="NucleusSecurityPageTHD">
                              <CustomerAccountNavigation/>
                          </QueryProvider>
                      </ErrorBoundary>
                  </div>
                  <div className='sui-grid sui-col-span-12 md:sui-col-span-12 lg:sui-col-span-9 xl:sui-col-span-7 2xl:sui-col-span-7 sui-p-4 sui-h-fit'>
                      <AccountProvider>
                          <StencilGlobalAlert/>
                          <SignInDetails/>
                          <AccountActivityLogComponent/>
                          <DeviceManagement/>
                      </AccountProvider>
                  </div>
              </div>
          </div>
      </div>
    </div>
  )
}

Home.displayName = "HomePage";
